module.exports = __webpack_public_path__ + "img/logo-avatar_manyu.7415fd32.png";